import React, { useState } from 'react'

import { Box } from '@myxplor/stardust'

import SurveyEditor from '~/components/SurveyEditor'

import { isIFrame, prodadminHosts } from '../../utils/helpers'

const Editor = props => {
  const [token, setToken] = useState('')

  if (!isIFrame) {
    const queryToken = new URLSearchParams(window.location.search).get('token')
    return (
      <Box>
        <SurveyEditor token={queryToken} {...props} />
      </Box>
    )
  }

  parent.postMessage({ type: 'getAccessToken', message: undefined }, '*')

  const handleMessage = evt => {
    if (prodadminHosts.includes(evt.origin)) {
      setToken(evt.data.message)
    }
  }

  if (window.addEventListener) {
    // For standards-compliant web browsers
    window.addEventListener('message', handleMessage, false)
  } else {
    window.attachEvent('onmessage', handleMessage)
  }

  return <Box>{token && <SurveyEditor token={token} {...props} />}</Box>
}

export default Editor
